"use client"
import { useState } from "react"
import { useLanguage } from "../contexts/LanguageContext"
import { Icons } from "./Icons"
import Mental from "../trainers/mental/Mental"
import InteractiveTextbookForPreschoolers from "../trainers/itfp/InteractiveTextbookForPreschoolers"

const TRAINING_MODULES = {
  MENTAL: "mental",
  MEMORY: "memory",
  LOGIC: "logic",
}

export function TrainingRouter({ onBack, showAddons = false }) {
  const { t } = useLanguage()
  const [currentTraining, setCurrentTraining] = useState(null)

  // Показываем список доступных тренингов
  return (
    <>
      {currentTraining ? (<div className="modal-overlay">
        <div className="modal-content full-modal-content">

          {currentTraining === TRAINING_MODULES.MENTAL ? (
            <Mental onClose={() => setCurrentTraining(null)} />
          ) : currentTraining === TRAINING_MODULES.MEMORY ? (
            <InteractiveTextbookForPreschoolers onClose={() => setCurrentTraining(null)} />
          // ) : currentTraining === TRAINING_MODULES.LOGIC ? (
          //   <LogicTraining onClose={() => setCurrentTraining(null)} />
          ) : null}
        </div>
      </div>) : null}
      <div className="space-y-6 p-6 bg-white rounded-lg shadow-md">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl font-bold flex items-center space-x-3">
            <Icons.Book className="w-8 h-8 text-blue-600" />
            <span>{t("trainings.title")}</span>
          </h1>
          <button onClick={onBack} className="btn btn-secondary flex items-center space-x-2">
            <Icons.ArrowLeft className="w-4 h-4" />
            <span>{t("trainings.back")}</span>
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Ментальная арифметика */}
          <div className="card">
            <div className="card-content">
              <div className="text-center p-6">
                <Icons.Abacus className="w-12 h-12 mx-auto mb-4 text-blue-600" />
                <h3 className="font-semibold text-lg mb-2">{t("trainings.mental")}</h3>
                <p className="text-sm text-gray-600 mb-4">{t("trainings.mental.description")}</p>
                <button
                  className="btn btn-primary w-full flex items-center justify-center space-x-2"
                  onClick={() => setCurrentTraining(TRAINING_MODULES.MENTAL)}
                >
                  <Icons.Abacus className="w-4 h-4" />
                  <span>{t("training.start")}</span>
                </button>
              </div>
            </div>
          </div>

          {/* Тренировка памяти */}
          {showAddons && (<div className="card">
            <div className="card-content">
              <div className="text-center p-6">
                <Icons.Brain className="w-12 h-12 mx-auto mb-4 text-green-600" />
                <h3 className="font-semibold text-lg mb-2">{t("trainings.memory")}</h3>
                <p className="text-sm text-gray-600 mb-4">{t("trainings.memory.description")}</p>
                <button
                  className="btn btn-primary w-full flex items-center justify-center space-x-2"
                  onClick={() => setCurrentTraining(TRAINING_MODULES.MEMORY)}
                >
                  <Icons.Brain className="w-4 h-4" />
                  <span>{t("training.start")}</span>
                </button>
              </div>
            </div>
          </div>)}

          {/* Логические задачи */}
          {/* <div className="card">
            <div className="card-content">
              <div className="text-center p-6">
                <Icons.Puzzle className="w-12 h-12 mx-auto mb-4 text-purple-600" />
                <h3 className="font-semibold text-lg mb-2">{t("trainings.logic")}</h3>
                <p className="text-sm text-gray-600 mb-4">{t("trainings.logic.description")}</p>
                <button
                  className="btn btn-primary w-full flex items-center justify-center space-x-2"
                  onClick={() => setCurrentTraining(TRAINING_MODULES.LOGIC)}
                >
                  <Icons.Puzzle className="w-4 h-4" />
                  <span>{t("training.start")}</span>
                </button>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  )
}

// Заглушки для других тренингов
function MemoryTraining({ onClose }) {
  const { t } = useLanguage()

  return (
    <div className="space-y-6 p-6 bg-white rounded-lg shadow-md">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold flex items-center space-x-3">
          <Icons.Brain className="w-8 h-8 text-green-600" />
          <span>{t("trainings.memory")}</span>
        </h1>
        <button onClick={onClose} className="btn btn-secondary flex items-center space-x-2">
          <Icons.Close className="w-4 h-4" />
          <span>{t("common.close")}</span>
        </button>
      </div>
      <div className="text-center p-8">
        <Icons.Brain className="w-24 h-24 mx-auto mb-4 text-green-300" />
        <p className="text-lg text-gray-600">{t("trainig.notImplemented")}</p>
      </div>
    </div>
  )
}

function LogicTraining({ onClose }) {
  const { t } = useLanguage()

  return (
    <div className="space-y-6 p-6 bg-white rounded-lg shadow-md">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold flex items-center space-x-3">
          <Icons.Puzzle className="w-8 h-8 text-purple-600" />
          <span>{t("trainings.logic")}</span>
        </h1>
        <button onClick={onClose} className="btn btn-secondary flex items-center space-x-2">
          <Icons.Close className="w-4 h-4" />
          <span>{t("common.close")}</span>
        </button>
      </div>
      <div className="text-center p-8">
        <Icons.Puzzle className="w-24 h-24 mx-auto mb-4 text-purple-300" />
        <p className="text-lg text-gray-600">{t("trainig.notImplemented")}</p>
      </div>
    </div>
  )
}
